import _import from './config'
export default {
    path: 'educational',
    component: {
        template: '<router-view :key="$route.fullPath"/>'
    },
    name: 'educational',
    redirect: '/educational/classList',
    children: [
        {
            path: 'classList',
            component: _import('educational/classList'),
            name: 'classList',
            meta: {
                auth: true
            }
        },{
            path: 'changeClassList',
            component: _import('educational/changeClassList'),
            name: 'changeClassList',
            meta: {
                auth: true
            }
        }, {
            path: 'fulltimeschedule',
            component: _import('educational/fullTimeSchedule'),
            name: 'fulltimeschedule',
            meta: {
                auth: true
            }
        }, {
            path: 'fulltimeTable',
            component: _import('educational/fullTimeTable'),
            name: 'fulltimeTable',
            meta: {
                auth: true
            }
        },{
            path: 'supclassList',
            component: _import('educational/superClassList'),
            name: 'supclassList',
            meta: {
                auth: true
            }
        }, {
            path: 'classSignList',
            component: _import('educational/classSignList'),
            name: 'classSignList',
            meta: {
                auth: true
            }
        }, {
            path: 'personalSchedule',
            component: _import('educational/personalSchedule'),
            name: 'personalSchedule',
            meta: {
                auth: true
            }
        }, {
            path: 'retroactiveList',
            component: _import('educational/retroactiveList'),
            name: 'retroactiveList',
            meta: {
                auth: true
            }
        }, {
            path: 'scheduleAll',
            component: _import('educational/scheduleAll'),
            name: 'scheduleAll',
            meta: {
                auth: true
            }
        }, {
            path: 'kebiaoall',
            component: _import('educational/kebiaoAll'),
            name: 'kebiaoall',
            meta: {
                auth: true
            }
        }, {
            path: 'supkebiaoall',
            component: _import('educational/superKebiaoAll'),
            name: 'supkebiaoall',
            meta: {
                auth: true
            }
        }, {
            path: 'schedulingList',
            component: _import('educational/schedulingList'),
            name: 'schedulingList',
            meta: {
                auth: true
            }
        }, {
            path: 'supschedulingList',
            component: _import('educational/superScheduleList'),
            name: 'supschedulingList',
            meta: {
                auth: true
            }
        }, {
            path: 'spreadClassList',
            component: _import('educational/spreadClassList'),
            name: 'spreadClassList',
            meta: {
                auth: true
            }
        }, {
            path: 'teacherList',
            component: _import('educational/teacherList'),
            name: 'teacherList',
            meta: {
                auth: true
            }
        }, {
            path: 'teacherclasssign',
            component: _import('educational/teacherClassSign'),
            name: 'teacherclasssign',
            meta: {
                auth: true
            }
        }, {
            path: 'supteacherclasssign',
            component: _import('educational/superTeacherClassSign'),
            name: 'supteacherclasssign',
            meta: {
                auth: true
            }
        }, {
            path: 'studentclasssign',
            component: _import('educational/studentClassSign'),
            name: 'studentclasssign',
            meta: {
                auth: true
            }
        }, {
            path: 'supstudentclasssign',
            component: _import('educational/superStudentClassSign'),
            name: 'supstudentclasssign',
            meta: {
                auth: true
            }
        }, {
            path: 'itsreacord',
            component: _import('educational/itsReacord'),
            name: 'itsreacord',
            meta: {
                auth: true
            }
        }, {
            path: 'classlog',
            component: _import('educational/classOnLog'),
            name: 'classlog',
            meta: {
                auth: true
            }
        }, {
            path: 'schedulecopy',
            component: _import('educational/scheduleCopy'),
            name: 'schedulecopy',
            meta: {
                auth: true
            }
        }
    ]
}


// WEBPACK FOOTER //
// ./src/router/education.js